module.exports = __webpack_public_path__ + "img/ZWF_Alicja_Strzalkowska.1653d663.jpg";